<div [formGroup]="form">
  <div class="row">
    <div class="col-12 col-lg-8">
      <app-multi-select-button-group [fieldsEnum]="Weekdays"
                                     id="weekdays"
                                     [form]="form"
                                     [translateKey]="'i18n.shared.weekdays.'">
      </app-multi-select-button-group>
    </div>
    <div class="col-12 col-lg-4 mt-2 mt-lg-0">
      <div class="e-btn-group">
        <input type="button"/>
        <label class="e-btn"
               [ngClass]="{'e-btn-active': weekdaysActive(), 'disabled': areWeekdaysDisabled()}"
               (click)="selectWeekdays()">
          {{ 'i18n.shared.fields.workdays' | translate}}
        </label>
        <input type="button"/>
        <label class="e-btn"
               [ngClass]="{'e-btn-active': weekendActive(), 'disabled': areWeekendsDisabled()}"
               (click)="selectWeekend()">
          {{ 'i18n.shared.fields.weekend' | translate}}
        </label>
        <input type="button"/>
        <label class="e-btn"
               [ngClass]="{'e-btn-active': allActive(), 'disabled': areAllDaysDisabled()}"
               (click)="selectAll()">
          {{ 'i18n.shared.fields.all' | translate}}
        </label>
      </div>
    </div>
  </div>
</div>
